import type { useTranslations } from 'next-intl'
import { z } from 'zod'

export function getLoginFormSchema({
  t,
}: {
  t: ReturnType<typeof useTranslations>
}) {
  return z.object({
    email: z.string().min(2, {
      message: t('form.inputs.email.minCharacters'),
    }),
    password: z.string().min(1, {
      message: t('form.inputs.password.minCharacters'),
    }),
  })
}

export type LoginFormValues = z.infer<ReturnType<typeof getLoginFormSchema>>
